import { SET_BULK_OPERATIONS_STATUS } from "./BulkOperationStatusActionTypes"

export function setBulkOperationsStatus(bulkOperationsStatus: string) {
    return {
        type: SET_BULK_OPERATIONS_STATUS,
        payload: {
            BulkOperationsStatus: bulkOperationsStatus,
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperationStatusActions.ts